<ion-grid class="table height-toolbar-2">

	<ion-row class="table-header">
		<ion-col size="1" class="flex-align-center">#</ion-col>
		<ion-col size="1" class="flex-align-center" i18n=":@@configurations_menu_component.icon">Icon</ion-col>
		<ion-col class="flex-align-center" i18n=":@@configurations_menu_component.name">Nome</ion-col>
		<ion-col class="flex-justify-start ion-hide-md-down" i18n=":@@configurations_menu_component.path">Endereço</ion-col>
		<ion-col class="flex-justify-center icon-status-size-2" i18n=":@@configurations_menu_component.availability"></ion-col>
		<ion-col class="flex-align-center buttons-size-3"></ion-col>
	</ion-row>

	<!-- <ng-container *cdkVirtualFor="let item of Data; let itemBounds = bounds;"> -->
	<ng-container *ngFor="let item of Data;">

		<ion-row class="table-body table-inner-header">

			<ion-col size="6" class="flex-justify-start">{{ item?.Platform?.Name ||'--' }}</ion-col>
			<ion-col></ion-col>

		</ion-row>

		<ion-reorder-group (ionItemReorder)="OnReorder($event, item.Menus)" [disabled]="!Reorder">

			<ion-row *ngFor="let menu of item?.Menus" style="display: block;">
				<ion-item class="ion-no-margin">
					<ion-reorder slot="end"></ion-reorder>
					<ion-grid class="ion-no-margin ion-no-padding">

						<ion-row class="table-body with-button-opacity">
							<ion-col size="1" class="flex-align-center">
								{{ menu?.NavigationPosition??'--' }}
							</ion-col>
							<ion-col size="1" class="flex-align-center">
								<ion-icon [name]="menu?.NavigationIcon"></ion-icon>
							</ion-col>
							<ion-col class="flex-align-center">{{ menu?.Name }}</ion-col>

							<ion-col class="flex-justify-start ion-hide-md-down">
								{{ menu?.NavigationPath }}
							</ion-col>
							<ion-col class="flex-justify-center icon-status-size-2">

								<icon-status icon="ellipse-sharp" [title]="menu?.IsPublic?'ativo':'não ativo'"
									[color]="menu?.IsPublic ? 'success' : 'warning'"></icon-status>

							</ion-col>

							<ion-col class="flex-justify-end buttons-size-3">

								<ng-container *ngIf="!Reorder">

									<ion-button fill="clear" color="dark" size="small" (click)="OnView(menu)"
										[actionsPermissions]="EnumActionsPermissions.VIEW">
										<ion-icon name="eye-outline" slot="icon-only"></ion-icon>
									</ion-button>

									<ion-button fill="clear" size="small" color="dark" (click)="OnEdit(menu)"
										[actionsPermissions]="EnumActionsPermissions.CREATEANDEDIT">
										<ion-icon name="create-outline" slot="icon-only"></ion-icon>
									</ion-button>

									<ion-button fill="clear" size="small" color="danger" (click)="OnDelete(menu)"
										[actionsPermissions]="EnumActionsPermissions.DELETE">
										<ion-icon name="trash-outline" slot="icon-only"></ion-icon>
									</ion-button>
								</ng-container>

							</ion-col>
						</ion-row>

					</ion-grid>
				</ion-item>

				<ion-item class="ion-no-margin" *ngFor="let child of menu?.Children">
					<!-- <ion-reorder slot="end"></ion-reorder> -->
					<ion-grid class="ion-no-margin ion-no-padding">
						<ion-row class="table-body with-button-opacity child">

							<ion-col size="1" class="flex-align-center">{{ child?.NavigationPosition ?? '--'
								}}</ion-col>
							<ion-col size="1" class="flex-align-center">
								<ion-icon [name]="child?.NavigationIcon"></ion-icon>
							</ion-col>

							<ion-col class="flex-align-center">{{ child?.Name }}</ion-col>

							<ion-col class="flex-justify-start ion-hide-md-down">
								{{ child?.NavigationPath }}
							</ion-col>
							<ion-col class="flex-justify-center icon-status-size-2">

								<icon-status icon="ellipse-sharp" [title]="child?.IsPublic?'ativo':'não ativo'"
									[color]="child?.IsPublic ? 'success' : 'warning'"></icon-status>

							</ion-col>

							<ion-col class="flex-justify-end buttons-size-3">

								<ng-container *ngIf="!Reorder">
									<ion-button fill="clear" size="small" color="dark" (click)="OnView(child)">
										<ion-icon name="eye-outline" slot="icon-only"></ion-icon>
									</ion-button>

									<ion-button fill="clear" size="small" color="dark" (click)="OnEdit(child)">
										<ion-icon name="create-outline" slot="icon-only"></ion-icon>
									</ion-button>

									<ion-button fill="clear" size="small" color="danger" (click)="OnDelete(child)">
										<ion-icon name="trash-outline" slot="icon-only"></ion-icon>
									</ion-button>
								</ng-container>

							</ion-col>

						</ion-row>

					</ion-grid>
				</ion-item>

			</ion-row>

		</ion-reorder-group>
	</ng-container>

	<ion-row *ngIf="!Data || Data?.length == 0">
		<ion-col>
			<no-items></no-items>
		</ion-col>
	</ion-row>

	<!-- <pagination-control [totalItems]="Data?.length" (pageChange)="OnChangePage($event)">
	</pagination-control> -->

</ion-grid>